import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess(customer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `customer/quality_control/query_container/${customer_id}/list_containers/agro_exporter_process/${agro_exporter_process_id}`
    );
  },

  fetchContainers(customer_id, agro_exporter_process_id, filters = {}) {
    return RequesterV1.get(
      `customer/quality_control/query_container/${customer_id}/list_containers/${agro_exporter_process_id}`,
      { params: filters }
    );
  },

  fetchExporterQualityTemplates(customer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `customer/quality_control/query_container/${customer_id}/list_containers/list_quality_templates/${agro_exporter_process_id}`
    );
  }
};
